(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["responsive-image-banner-sos"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sos-banner-slider')) {
    class SosBannerSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        if (!this.track) return;
        this.slides = Array.from(this.track.children);
        this.dots = Array.from(this.querySelectorAll('[data-dot]'));
        this.index = 0;
        this.timer = null;

        const prev = this.querySelector('[data-prev]');
        const next = this.querySelector('[data-next]');
        if (prev) prev.addEventListener('click', () => { this.stop(); this.go(this.index - 1); });
        if (next) next.addEventListener('click', () => { this.stop(); this.go(this.index + 1); });
        this.dots.forEach((dot, i) => dot.addEventListener('click', () => { this.stop(); this.go(i); }));

        // Keep dots in sync when the shopper swipes
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.index = this.slides.indexOf(entry.target);
                this.updateDots();
              }
            });
          },
          { root: this.track, threshold: 0.6 }
        );
        this.slides.forEach((slide) => this.observer.observe(slide));

        // Autoplay (paused on hover / focus / touch, off for reduced motion)
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.autoplay = this.dataset.autoplay === 'true' && !reduced && !window.Shopify?.designMode;
        this.speed = parseInt(this.dataset.speed, 10) || 5000;
        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('touchstart', () => this.stop(), { passive: true });
        this.start();

        // Theme editor: jump to the banner being edited
        this.addEventListener('shopify:block:select', (event) => {
          const i = this.slides.findIndex((slide) => slide.contains(event.target));
          if (i > -1) { this.stop(); this.go(i, false); }
        });
      }

      disconnectedCallback() {
        this.stop();
        if (this.observer) this.observer.disconnect();
      }

      go(i, smooth = true) {
        const count = this.slides.length;
        this.index = (i + count) % count;
        this.track.scrollTo({
          left: this.index * this.track.clientWidth,
          behavior: smooth ? 'smooth' : 'instant',
        });
        this.updateDots();
      }

      updateDots() {
        this.dots.forEach((dot, i) => {
          if (i === this.index) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      }

      start() {
        if (!this.autoplay || this.timer) return;
        this.timer = setInterval(() => this.go(this.index + 1), this.speed);
      }

      stop() {
        clearInterval(this.timer);
        this.timer = null;
      }
    }
    customElements.define('sos-banner-slider', SosBannerSlider);
  }

  } catch(e) { console.error(e); }
})();
})();
